/**
 * 工具类 create by gzf
 */
//事件绑定
export const addEvent = (() => {
    if (document.addEventListener) {
        return function (type, element, func) {
            element.addEventListener(type, func, false);
        };
    } else if (document.attachEvent) {
        return function (type, element, func) {
            element.attachEvent('on' + type, func);
        };
    } else {
        return function (type, element, func) {
            element['on' + type] = func;
        };
    }
})();

//将2017-10-20（或20171020）改成2017年10月20日
export const changeDateText = str => {
    let arr = [];
    if (str.indexOf('-') !== -1) {
        arr = str.split('-');
        arr.splice(1, 0, '年');
        arr.splice(3, 0, '月');
    } else {
        arr = str.split('');
        arr.splice(4, 0, '年');
        arr.splice(7, 0, '月');
    }
    return arr.join('') + '日';
};

//2018-05-23 => 5/23
export const getMonthDay = (str, spit) => {
    let r = str.split('-'),
        m = r[1].replace(/\b0/, ''),
        n = r[2].replace(/\b0/, '');
    return m + spit + n;
};

//转换格式，只要日期s
export const formateDate = (str, fmt) => {
    str = str.split(' ')[0];
    return str.replace(/[^\d]/g, fmt);
};

//生成uuid [参数: len-长度，radix进制]
export const createUUID = (len, radix) => {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(''),
        uuid = [], i;
    radix = radix || chars.length;
    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        var r;
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');
};

/*判断设备信息*/
const userAgent = navigator.userAgent;
export const BrowserInfo = {
    userAgent: userAgent,
    isAndroid: userAgent.match(/android/ig),
    isIphone: userAgent.match(/iphone|ipod/ig),
    isIpad: userAgent.match(/ipad/ig),
    isWeixin: userAgent.match(/MicroMessenger/ig), //微信
    isSinaWeibo: userAgent.match(/Weibo/ig), //新浪微博
    isQQ: userAgent.match(/QQ/ig), //QQ
    isAlipay: userAgent.match(/Alipay/ig), //支付宝
    isbyxf: userAgent.match(/byxf/ig), //包你还app
    isIosVersionLessThanSeven: function () {
        if (this.isIphone || this.isIpad) {
            return Boolean(userAgent.match(/os [1-6]_\d[_\d]* like mac/ig));
        }
        return false;
    }
};

export const isWeixin = () => navigator.userAgent.match(/MicroMessenger/ig);

//区分是App、其他渠道
export const isApp = () => navigator.userAgent.match(/byxf/ig);

//区分是App、生活号或其他渠道
export const getChannel = () => {
    if (BrowserInfo.isAlipay) {
        return 'alipay';
    } else if (BrowserInfo.isbyxf) {
        return 'app';
    } else {
        return 'web';
    }
};

//区分是android 还是 ios
export const getSystem = () => {
    if (BrowserInfo.isAndroid) {
        return 'android';
    } else if (BrowserInfo.isIphone || BrowserInfo.isIpad) {
        return 'ios';
    } else {
        return 'pc';
    }
};
/*今日头条埋点改版用*/
export const getSystemForJrtt = () => {
    if (BrowserInfo.isAndroid) {
        return 'android';
    } else if (BrowserInfo.isIphone || BrowserInfo.isIpad) {
        return 'ios';
    } else {
        return 'ios';  //服务端只支持安卓和ios两个字符串
    }
}

//获取URL参数
export const getUrlParam = name => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    //serach => ?name=1&id=tt
    return r != null ? r[2] : null;
};

export const urlParams = () => {
    var args = new Object();
    var query = location.search.substring(1);//获取查询串
    var pairs = query.split("&");
    for (var i = 0; i < pairs.length; i++) {
        var params = pairs[i].split('=');
        if (params.length < 2) continue;
        args[params[0]] = params[1];
    }
    return args;
};
//下载App
export const downLoadApp = () => {
    const androidUrl = 'http://www.baoyinxiaofei.com/byxf-offical.apk',
        iosUrl = 'https://itunes.apple.com/us/app/包银消费金融/id1168928180?l=zh&ls=1&mt=8',
        baoyinTencent = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.baoyin.credit',
        qdParams = getUrlParam();
    //广点通 || 今日头条
    if (qdParams && (qdParams.qdId == 'gdt' || qdParams.qdId == 'Alipay' || BrowserInfo.isWeixin || BrowserInfo.isAlipay)) {
        window.location.href = baoyinTencent;
    } else if (BrowserInfo.isIphone && BrowserInfo.isSinaWeibo) {
        let layer = document.getElementById('download_layer');
        layer.style.display = 'block';
        layer.onclick = function () {
            this.style.display = 'none';
        };
    } else if (BrowserInfo.isIphone) {
        window.location.href = iosUrl;
    } else if (BrowserInfo.isAndroid) {
        window.location.href = androidUrl;
    }
};

//原生Ajax请求
export const ajax = (option) => {
    console.log('网络请求参数---->', JSON.stringify(option))
    let opt = Object.assign({}, { type: 'POST', url: '', async: true, data: null, beforeSend: function () { }, success: function () { }, fail: function () { }, complete: function () { } }, option);
    const xhr = (window.XMLHttpRequest != undefined) ? (new XMLHttpRequest()) : (new ActiveXObject('Microsoft.XMLHttp'));
    if (opt.type.toUpperCase() === 'POST') {
        xhr.open(opt.type, opt.url, opt.async);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
        xhr.send(JSON.stringify(opt.data));
    } else {
        let params = [];
        for (let key in opt.data) params.push(key + '=' + opt.data[key]);
        let sendData = params.join('&');
        xhr.open(opt.type, opt.url + '?' + sendData, opt.async);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
        xhr.send(null);
    }
    opt.beforeSend();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            opt.async && opt.complete();
            if (xhr.status == 200) {
                opt.success(JSON.parse(xhr.responseText));
            } else {
                console.log('请求失败，请稍后重试');
                opt.fail();
            }
        }
    };
};


/** 校验验证码为5位数字 */
export function checkCode(str) {
    const reg = /^[0-9]{5,6}$/
    return reg.test(str)
}

//校验手机号正则
export const checkTel = str => /^1[3|4|5|7|8][0-9]{9}$/.test(str);

//身份证校验正则
export const checkIden = str => /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(str);

//fetch周年庆专题3
export const fetchPost = (url, data) => fetch(url, {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
}).then((response) => {
    if (response.ok) {
        return response.json();
    }
})

//fetch
/**
 * 将对象转成 a=1&b=2的形式
 * @param obj 对象
 */
function obj2String(obj, arr = [], idx = 0) {
    for (let item in obj) {
        arr[idx++] = [item, obj[item]]
    }
    return new URLSearchParams(arr).toString()
}

/**
 * 真正的请求
 * @param url 请求地址
 * @param options 请求参数
 * @param method 请求方式
 */
function commonFetcdh(url, options, method = 'GET') {
    const searchStr = obj2String(options)
    let initObj = {}
    if (method === 'GET') { // 如果是GET请求，拼接url
        url += '?' + searchStr
        initObj = {
            mode: 'no-cors',
            method: method,
            credentials: 'include'
        }
    } else {
        initObj = {
            mode: 'no-cors',
            method: method,
            credentials: 'include',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            body: searchStr
        }
    }
    fetch(url, initObj).then((res) => {
        return res.json()
    }).then((res) => {
        return res
    })
}

/**
 * GET请求
 * @param url 请求地址
 * @param options 请求参数
 */
export const fetchGET = (url, options) => {
    return commonFetcdh(url, options, 'GET')
}

/**
 * POST请求
 * @param url 请求地址
 * @param options 请求参数
 */
export const fetchPOST = (url, options) => {
    return commonFetcdh(url, options, 'POST')
}

/**
 * 猛犸事件处理
 * @param  event_type [事件名称]
 * @param  tick       [uuid]
 * @param  pointPage  [来源页面]
 * @param  callback   [description]
 */
export const mjHandler = (url, tid, event_type, tick, pointPage, callback) => {

    /*猛犸初始化*/
    mj('set_params', {
        url: url, // 事件发送地址
        tid: tid  // 绑定在平台上的 API key
    });
    /*事件绑定*/
    mj('customize_event', {
        "event_type": event_type,
        "tick": tick,
        "fields": {
            'from': pointPage
        }
    }, (status, data) => {
        // console.log('猛犸: ' + status);
        if (status) {
            setTimeout(callback(), 300);
        }
    }
    );
}

/* 进页面埋点 */
export const pageInBuryPointHandler = (pageInTick, qdParams, ajaxUrl) => {
    let pageInData = {
        "deviceNumber": pageInTick,
        "qdId": qdParams.qdId,
        "cyId": qdParams.cyId,
        "hdId": qdParams.hdId,
        "actType": '01',
        "system": getSystem(),
        "url": window.location.href,
        "slidingScreen": "2",
        "custNo": "",
        "mobileNo": "",
        "environmentInfo": {
            "gpsProvince": "北京市",
            "gpsCity": "北京市"
        },
        "terminalInfo": {
            "appType": getSystemForJrtt()
        }
    }
    ajax({
        url: ajaxUrl,
        data: pageInData,
        success: function (data) {
            // console.log('进页面埋点'+data.statusInfo.code);
        },
        error: function () {
            console.log("进页面埋点 请求失败")
        }
    })
}

//检查时间是否在时间段内,返回 0 未开始 1 已过期 2 正常
export const checkActTime = (start, end) => {
    var cur = Date.now();
    start = new Date(start.replace(/\-/g,'/')).getTime();
    end = new Date(end.replace(/\-/g,'/')).getTime();
    if (cur < start) {
        return 0;
    } else if (cur > end) {
        return 1;
    } else {
        return 2;
    }
}